import { use } from 'react';
import { AnimatedTabsContext } from './AnimatedTabsContext.tsx';

/**
 * {@link useAnimatedTabs} can be used by components in our app to get access to the user state
 * and authentication methods
 */
export function useAnimatedTabs() {
  const context = use(AnimatedTabsContext);

  if (context === undefined) {
    throw new Error('useAnimatedTabs must be used within an AnimatedTabsProvider');
  }
  return context;
}
